export enum AuthMethods {
    password = 'password',
    twoFAApp = '2fa_app',
    twoFAEnforced = '2fa_enforced'
}
